"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var gallery_card_component_1 = __importDefault(require("../../common-components/gallery-card/gallery-card.component"));

var select_image_styles_1 = require("./select-image.styles");

var image_card_component_1 = __importDefault(require("../image-card/image-card.component"));

var SelectImage = function SelectImage(_ref) {
  var images = _ref.images,
      handleSelectImage = _ref.handleSelectImage;
  return React.createElement(gallery_card_component_1.default, null, React.createElement(select_image_styles_1.StyledImageListWrapperDiv, null, !images.length ? React.createElement("p", null, "\u753B\u50CF\u304C\u5B58\u5728\u3057\u307E\u305B\u3093") : React.createElement(select_image_styles_1.StyledImagesUl, null, images.map(function (image, i) {
    return React.createElement("li", {
      key: i
    }, React.createElement(image_card_component_1.default, {
      image: image,
      onClick: function onClick() {
        return handleSelectImage(image);
      }
    }));
  }))));
};

exports.default = SelectImage;